<!-- Loading skeleton for timeline -->
<div  class="px-4 mt-6 space-y-6 loading-container">
  @for (item of [1, 2, 3, 4]; track item) {
    <div class="flex items-start space-x-3 skeleton-item">
      <div
        class="w-2 h-2 bg-mbaza-gray-dark rounded-full mt-2 flex-shrink-0 skeleton-pulse"
      ></div>
      <div class="flex-1 space-y-2">
        <div class="flex items-center space-x-2">
          <div class="h-3 skeleton-loading rounded w-24"></div>
          <div class="h-4 skeleton-loading rounded w-16"></div>
        </div>
        <div class="space-y-1">
          <div class="h-4 skeleton-loading rounded w-full"></div>
          <div class="h-4 skeleton-loading rounded w-3/4"></div>
        </div>
      </div>
    </div>
  }
</div>
